import api from '../../helpers/axios'
export const state = {
    lmsCourse: null,
    lmsCourses: [],
    customerUserId: null,
    props: {
        customerUserId: String,
        customerCourseId: String,
        examId: String,
        contentId: String,
    },
};

export const getters = {
    lmsCourse: (state) => state.lmsCourse,
    lmsCourses: (state) => state.lmsCourses,
};

export const mutations = {
    setLmsCourse(state, newValue) {
        state.lmsCourse = newValue;
    },
    setLmsCourses(state, newValue) {
        state.lmsCourses = newValue;
    },
    setCustomerUserId(state, newValue) {
        state.customerUserId = newValue;
    },
    setCustomerCourseId(state, newValue) {
        state.customerCourseId = newValue;
    },
};

export const actions = {
    createLmsCourse(_,  {data, customerUserId}) {
        return new Promise((resolve,reject) => {
            api.post(`/customer-users/${customerUserId}/courses`, data).then((res) => {
                if(res){
                    resolve(res.data.data)
                }
            }).catch((err) => {
                reject(err)
            })
        });
    },


    deleteLmsCourse(_,{customerUserId, customerCourseId }) {
        return new Promise((resolve) => {
            api.delete(`/customer-users/${customerUserId}/courses/${customerCourseId}`).then((res) => {
                resolve(res.data.data);
            });
        });
    },


    fetchLmsCourse({ commit }, {id}) {
        return new Promise((resolve,reject) => {
            api.get("/customer-users/"+id).then((res) => {
                commit("setLmsCourse", res.data.data);
                resolve(res.data.data)
            }).catch(err=>{
                reject(err)
            })
        });
    },

    fetchLmsCourses({ commit }, { level,education, site, isActive, page, limit, listType, customerUserId }) {
        let query = "?";

        if (listType) {
            query += `listType=${listType}&`;
        } else {
            query += `page=${page}&`;
            query += `limit=${limit}&`;
        }

      if (education) {
            query += `education=${education}&`;
        }

        if (level) {
            query += `rates=${level}&`;
        }

        if (site) {
            query += `site=${site}&`;
        }
        if (isActive !== undefined) {
            query += `isActive=${isActive}&`;
        }
        return new Promise((resolve) => {
            api.get(`/customer-users/${customerUserId}/courses`+ query).then((res) => {
                commit("setLmsCourses", res.data.data);
                resolve(res.data.data);
            });
        });
    },
};
